import { render, staticRenderFns } from "./LimitedModal.vue?vue&type=template&id=0852bf30&scoped=true"
import script from "./LimitedModal.vue?vue&type=script&lang=js"
export * from "./LimitedModal.vue?vue&type=script&lang=js"
import style0 from "./LimitedModal.vue?vue&type=style&index=0&id=0852bf30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852bf30",
  null
  
)

export default component.exports